import { render, staticRenderFns } from "./SubscribeV2.vue?vue&type=template&id=2a8bd45b&"
import script from "./SubscribeV2.vue?vue&type=script&lang=js&"
export * from "./SubscribeV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports